import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import ClarksonsCloudHeader from './components/clarksons/ClarksonsCloudHeader';
import GlobalSubscriptions from './components/GlobalSubscriptions';
import MultiPage from './components/multi/MultiPage';
import SinglePage from './components/single/SinglePage';
import NotificationMessages from './components/NotificationMessages';
import AdvancedAnalyticsPage from './components/analytics/AdvancedAnalyticsPage';
import { Modal } from 'common';
import { withRouter } from 'react-router';
import { enableVesselFixturesPage } from '_legacy/config';
import { sharedRoutes } from './models/SharedRoutes';
import { RouteRetainer } from './components/single/RouteRetainer';
import HealthPage from 'components/health/healthPage';
class routes extends Component {
    render() {
        const pathname = this.props.location.pathname;
        const match = pathname.match(/\/vessel\/(\d+)\/fixtures/);
        const vesselImo = match ? match[1] : null;
        const isVesselView = enableVesselFixturesPage && !!vesselImo;
        const isIframeView = pathname.startsWith('/titan');
        const hideHeader = isVesselView || isIframeView;

        return (
            <div>
                <ClarksonsCloudHeader hidden={hideHeader} hide={hideHeader} />
                <Modal />
                <div
                    className={`ui fluid container flex-layout-container light-background ${
                        isVesselView ? 'vesselView' : ''
                    } ${isIframeView ? 'titanView' : ''}`}
                >
                    <div
                        id="appContainer"
                        className="flex-item-fill"
                        style={{ width: '100%' }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                height: '100%',
                            }}
                        >
                            <GlobalSubscriptions />
                            <NotificationMessages className="brand-header-part" />
                            <RouteRetainer />
                            <div
                                style={{
                                    position: 'relative',
                                    flexGrow: 1,
                                    height: '100%',
                                }}
                            >
                                <div
                                    style={{
                                        position: 'absolute',
                                        height: '100%',
                                        width: '100%',
                                    }}
                                >
                                    <Switch>
                                        <Route
                                            exact
                                            path="/analytics/:token"
                                            component={AdvancedAnalyticsPage}
                                        />
                                        <Route
                                            exact
                                            path="/health"
                                            component={HealthPage}
                                        />
                                        <Route
                                            exact
                                            path={sharedRoutes.multi}
                                            component={MultiPage}
                                        />
                                        <Route component={SinglePage} />
                                    </Switch>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(routes);
